module.exports = __webpack_public_path__ + "static/media/ic_nav_favorite.5dfeb74d.svg";